import React from "react";
import { Trans, useTranslation } from "react-i18next";

const CoWorkingAbout = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className='relative mt-3 md:mt-10'>
        <h1 className='text-5xl font-bold leading-[1.1] text-center'>
          {t("cw_lp_home_4")}
        </h1>
      </div>

      <div className='flex flex-col items-center max-w-screen-2xl mx-auto pt-10 mb-10 px-4'>
        <div className='w-full'>
          <p className='text-md font-medium text-center'>{t("cw_lp_home_5")}</p>
          <p className='text-md font-medium text-center'>{t("cw_lp_home_6")}</p>
        </div>
      </div>
      <div className='w-full bg-[#211916] px-4 text-white py-8'>
        <div className='md:max-w-5xl lg:max-w-6xl mx-auto'>
          <div className='text-center'>
            <h2 className='text-3xl md:text-5xl font-bold'>
              {t("cw_lp_home_about_0")}
            </h2>
          </div>

          <div className='flex flex-col items-center max-w-screen-2xl mx-auto py-8'>
            <div className='w-full'>
              <p className='text-md font-medium text-center'>
                {t("cw_lp_home_about_0.1")}
              </p>
            </div>
          </div>

          <div className='w-full mb-10'>
            <p className='text-xl md:text-3xl font-bold mb-1'>
              {t("cw_lp_home_about_1")}
            </p>
            <p className='text-sm'>{t("cw_lp_home_about_2")}</p>
          </div>

          <div className='flex flex-col gap-4 md:gap-6'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10'>
              {/* Left Column */}
              <div className='flex flex-col h-full'>
                <a
                  href={t("cw_lp_home_about_2_8")}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='font-bold underline'
                >
                  {t("cw_lp_home_about_2_7")}
                </a>
                <p className='text-sm flex-grow'>
                  {t("cw_lp_home_about_2_7.1")}
                </p>

                <div className='relative w-full h-60 mt-4 overflow-hidden'>
                  <img
                    src='/assets/images/landing/coWorkingEvent.png'
                    alt='event program'
                    className='w-full h-full object-cover object-bottom'
                  />
                </div>
              </div>

              {/* Right Column */}
              <div className='flex flex-col h-full mt-6 md:mt-0'>
                <a
                  href={t("cw_lp_home_about_3.2")}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='font-bold underline break-words w-full'
                >
                  {t("cw_lp_home_about_3")}
                </a>
                <p className='text-sm flex-grow'>{t("cw_lp_home_about_3.1")}</p>

                <div className='relative w-full h-60 mt-4 overflow-hidden'>
                  <img
                    src='/assets/images/landing/coordination.JPG'
                    alt='coordination'
                    className='w-full h-full object-cover'
                  />
                </div>
              </div>
            </div>

            {/* Second Section */}
            <div>
              <p className='text-xl md:text-3xl font-bold mb-1 mt-6 md:mt-0'>
                {t("cw_lp_home_about_2_1_b")}
              </p>
              <p className='text-sm'>{t("cw_lp_home_about_2_1_c")}</p>
              <p className='text-sm pt-3'>{t("cw_lp_home_about_2_1_d")}</p>

              <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10 pt-4'>
                {/* First Column */}
                <div className='flex flex-col h-full'>
                  <p className='text-sm font-bold mb-2'>
                    <a
                      href={t("cw_lp_home_about_2_3")}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='font-bold underline'
                    >
                      {t("cw_lp_home_about_2_1")}
                    </a>
                  </p>
                  <p className='text-sm flex-grow'>
                    {t("cw_lp_home_about_2_2")}
                  </p>
                  <div className='relative w-full h-60 mt-4 overflow-hidden'>
                    <img
                      src='/assets/images/landing/ventureCafe.png'
                      alt='event program'
                      className='w-full h-full object-cover'
                    />
                  </div>
                </div>

                {/* Second Column - The Mobility (removed temporarily, will be replaced later)
                <div className='flex flex-col h-full'>
                  <p className='text-sm font-bold mb-2'>
                    <a
                      href={t("cw_lp_home_about_4_b")}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='font-bold underline'
                    >
                      {t("cw_lp_home_about_4")}
                    </a>
                  </p>
                  <p className='text-sm flex-grow'>
                    <Trans i18nKey='cw_lp_home_about_4_a' />
                  </p>
                  <div className='relative w-full h-60 mt-4 overflow-hidden'>
                    <img
                      src='/assets/images/landing/theMobility.png'
                      alt='theMobility'
                      className='w-full h-full object-cover'
                    />
                  </div>
                </div>
                */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* facility section */}
      <div
        className='md:max-w-5xl lg:max-w-6xl mx-auto px-4 md:px-0'
        id='facility'
      >
        <div className='flex flex-col items-center text-center mb-9 md:pb-5 pt-8 md:pt-12'>
          <h1 className='text-3xl md:text-5xl font-bold title-font'>
            {t("cw_lp_home_about_facility_1")}
          </h1>
        </div>

        <div className='relative w-full h-[200px] md:h-[500px]'>
          <img
            src='/assets/images/landing/facility.jpg'
            alt='facility'
            className='absolute inset-0 object-cover'
            style={{ width: "100%", height: "100%" }}
          />
        </div>

        <div className='grid gap-4 md:py-6 max-w-screen-2xl mx-auto sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3'>
          <div className='relative'>
            <div className='relative w-full h-0 pb-[56.25%] overflow-hidden'>
              <img
                src='/assets/images/landing/loungeDaytime.png'
                alt='work lounge'
                className='absolute inset-0 object-cover'
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <div className='pt-2'>
              <h3 className='text-lg font-bold title-font'>
                {t("cw_lp_home_about_facility_2")}
              </h3>
              <p className='leading-relaxed text-xs'>
                {t("cw_lp_home_about_facility_3")}
              </p>
              <p className='leading-relaxed text-xs'>
                {t("cw_lp_home_about_facility_4")}
              </p>
            </div>
          </div>

          <div className='relative'>
            <div className='relative w-full h-0 pb-[56.25%] overflow-hidden'>
              <img
                src='/assets/images/landing/cafeNoon.png'
                alt='cafe'
                className='absolute inset-0 object-cover'
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <div className='pt-2'>
              <h3 className='text-lg font-bold title-font'>
                {t("cw_lp_home_about_facility_5")}
              </h3>
              <p className='leading-relaxed text-xs'>
                <Trans
                  i18nKey='cw_lp_home_about_facility_6'
                  components={[
                    <a
                      href={t("cw_lp_instagram_url")}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='underline'
                    />,
                  ]}
                />
              </p>
              <p className='leading-relaxed text-xs'>
                {t("cw_lp_home_about_facility_7")}
              </p>
            </div>
          </div>

          <div className='relative'>
            <div className='relative w-full h-0 pb-[56.25%] overflow-hidden'>
              <img
                src='/assets/images/landing/loungeExhibition.png'
                alt='loungeExhibition room'
                className='absolute inset-0 object-cover'
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <div className='pt-2'>
              <h3 className='text-lg font-bold title-font'>
                {t("cw_lp_home_about_facility_8")}
              </h3>
              <p className='leading-relaxed text-xs'>
                {t("cw_lp_home_about_facility_9")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoWorkingAbout;
